import { get } from "lodash";
import { createSelector } from "reselect";

import { getEstimateScheduleArray } from "../schedules/scheduleUtils.js";
import { operationAvailability } from "../../../utils/operations.js";

import { ENDPOINTS } from "../../../constants/api.js";
import { AT_TYPES } from "../../../constants/entity.js";
import { OPERATIONS } from "../../../constants/operations.js";

import endpointSelector from "../endpoints/endpointSelector.js";

// -- QUERIES -- //

const estimatesDataQuery = state => get(state, "estimates.dataMap", null);

const schedulesFromFormikProps = (state, props) => {
  const schedule = get(props, "formikProps.values.schedule", null);
  return getEstimateScheduleArray(schedule);
};

const dataOperationsFromPropsQuery = (state, props) => {
  let operations = get(props, "data.operations", null);
  return operations;
};

// -- SELECTORS -- //

const selectEstimates = createSelector(
  [schedulesFromFormikProps, estimatesDataQuery],
  (schedules, dataMap) => {
    if (!schedules || !dataMap) return null;

    return schedules
      .map(schedule => {
        const id = schedule.replace(`${ENDPOINTS.SCHEDULES}/`, "");
        // update to RESOURCE_KEYS.ESTIMATES once api is updated to prepend /projects/estimate
        return dataMap[`/estimates/${id}`];
      })
      .filter(item => item);
  }
);

const selectEstimatesByAtIDs = atIDs => {
  return createSelector([estimatesDataQuery], dataMap => {
    if (!atIDs || !dataMap) return [];

    return atIDs.map(atID => {
      // update to RESOURCE_KEYS.ESTIMATES once api is updated to prepend /projects/estimate
      return dataMap[`/estimates/${atID}`];
    });
  });
};

const selectEstimateEndpointAvailability = state => {
  return endpointSelector.selectOperationAvailability(state)(
    AT_TYPES.ESTIMATE,
    OPERATIONS.ESTIMATE
  );
};

const selectEstimateIsAvailabile = createSelector(
  [selectEstimateEndpointAvailability, dataOperationsFromPropsQuery],
  (estimateEndpointAvailabilty, dataOperations) => {
    // prefer account level permissions
    if (estimateEndpointAvailabilty && estimateEndpointAvailabilty.available) {
      return true;
    }

    // check project level permissions if not
    if (dataOperations) {
      const availability = operationAvailability(
        OPERATIONS.ESTIMATE,
        dataOperations,
        false
      );

      return !!availability.available;
    }

    return false;
  }
);

// using the following export pattern so we can mock more easily using jest

const estimateSelector = {
  selectEstimates,
  selectEstimatesByAtIDs,
  selectEstimateEndpointAvailability,
  selectEstimateIsAvailabile
};

export default estimateSelector;
